import {
    PrismicRichText as BasePrismicRichText,
    PrismicRichTextProps,
  } from '@prismicio/react';
  
  const defaultComponents = {};
  
  export const PrismicRichText = ({
    components,
    ...props
  }: PrismicRichTextProps) => {
    return (
      <BasePrismicRichText
        components={{ ...defaultComponents, ...components }}
        {...props}
      />
    );
  };
  
  const defaultHighLineComponents = {
    strong: ({ children }) => (
      <strong className="rounded-md bg-primary px-0.5">{children}</strong>
    ),
  };
  
  export const PrismicRichTextHighLine = ({
    components,
    ...props
  }: PrismicRichTextProps) => {
    return (
      <BasePrismicRichText
        components={{ ...defaultHighLineComponents, ...components }}
        {...props}
      />
    );
  };
  
  const defaultHighLineBlueComponents = {
    strong: ({ children }) => (
      <strong className="rounded-md bg-dark-blue px-0.5 text-white">
        {children}
      </strong>
    ),
  };
  
  export const PrismicRichTextHighLineBlue = ({
    components,
    ...props
  }: PrismicRichTextProps) => {
    return (
      <BasePrismicRichText
        components={{ ...defaultHighLineBlueComponents, ...components }}
        {...props}
      />
    );
  };
  